<template>
  <div>
    <div v-if="this.loading">
      Loading.....
    </div>
    <div v-else-if="this.errormessage">
      <oops :errormsg="errormessage" />
    </div>
    <div v-else-if="!this.loading && !this.errormessage">
      <course-header-edit />
      <course-session-edit />
    </div>
  </div>
</template>

<script>
import courseApi from '@/services/api/course'
import oops from '@/components/_main/oops.vue'
import CourseHeaderEdit from '@/components/course/course-header-edit.vue'
import CourseSessionEdit from '@/components/course/course-session-edit.vue'

export default {
  name: 'CourseEdit',
  components: {
    oops,
    CourseHeaderEdit,
    CourseSessionEdit
  },
  data: function () {
    return {
      course: null,
      loading: true,
      errormessage: null
    }
  },
  mounted () {
    courseApi.get(this.$root.courseKey)
      .then(x => {
        this.course = x
      })
      .catch(error => {
        console.log(error)
        this.$notify({
          message: 'There was an error retrieving your data.',
          icon: 'bi bi-exclamation-circle-fill',
          type: 'error',
          horizontalAlign: 'center',
          timeout: 2000
        })
        this.errormessage = error
      })
      .finally(() => {
        this.loading = false
      })
  }
}
</script>
